export default "__VITE_ASSET__CuHvMhjE__"